export function withLiveFields<T extends object, K extends keyof T & string>(
  target: Omit<T, K>,
  host: object,
  keys: K[]
): T {
  const fields = host as Record<string, unknown>;
  for (const key of keys) {
    Object.defineProperty(target, key, {
      enumerable: true,
      get: () => fields[key],
      set: (value) => {
        fields[key] = value;
      },
    });
  }
  return target as T;
}
